import ItemQuantityHandler from './ItemQuantityHandler';

export default ItemQuantityHandler;
